import React from "react";
function Navbar() {
	const logo = "img/logo.png";
	const [open, setOpen] = React.useState(false);

	const toggle = () => {
		setOpen((prevState) => !prevState);
	};
	return (
		<nav className="own-bg ">
			<div className="max-w-6x mx-auto px-4">
				<div className="flex justify-between">
					<div className="flex space-x-7">
						<div>
							<button href="#" className="flex items-center py-4 px-2">
								<img src={logo} alt="Logo" className="h-10 w-full mr-2" />
							</button>
						</div>
					</div>
					{/* button */}
					<div className="flex items-center">
						<button
							disabled={open}
							onClick={toggle}
							className="outline-none mobile-menu-button">
							<svg
								className=" w-8 h-8 text-white hover:text-green-500 "
								x-show="!showMenu"
								fill="none"
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								viewBox="0 0 24 24"
								stroke="currentColor">
								<path d="M4 6h16M4 12h16M4 18h16"></path>
							</svg>
						</button>
					</div>
					{/* return */}
					<Sidenav open={open} toggle={toggle}>
						<SidenavItem href="#gellary">
							<span onClick={toggle} className="pl-2 uppercase">
								Gellary
							</span>
						</SidenavItem>
						<SidenavItem href="#festival">
							<h1 onClick={toggle} className="pl-2 uppercase">
								Festival
							</h1>
						</SidenavItem>
						<SidenavItem href="#roadmap">
							<span onClick={toggle} className="pl-2 uppercase">
								RoadMap
							</span>
						</SidenavItem>
						<SidenavItem href="#faq">
							<span onClick={toggle} className="pl-2 uppercase">
								Faq
							</span>
						</SidenavItem>
						<div className="absolute  bottom-4 flex w-full justify-center">
							<a
								onClick={toggle}
								href="https://discord.gg/AxY67smD"
								class="px-4 py-2 font-semibold text-white inline-flex items-center space-x-2 rounded">
								<svg
									class="w-5 h-5 fill-current"
									viewBox="0 0 71 55"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<g clip-path="url(#clip0)">
										<path
											d="M60.1045 4.8978C55.5792 2.8214 50.7265 1.2916 45.6527 0.41542C45.5603 0.39851 45.468 0.440769 45.4204 0.525289C44.7963 1.6353 44.105 3.0834 43.6209 4.2216C38.1637 3.4046 32.7345 3.4046 27.3892 4.2216C26.905 3.0581 26.1886 1.6353 25.5617 0.525289C25.5141 0.443589 25.4218 0.40133 25.3294 0.41542C20.2584 1.2888 15.4057 2.8186 10.8776 4.8978C10.8384 4.9147 10.8048 4.9429 10.7825 4.9795C1.57795 18.7309 -0.943561 32.1443 0.293408 45.3914C0.299005 45.4562 0.335386 45.5182 0.385761 45.5576C6.45866 50.0174 12.3413 52.7249 18.1147 54.5195C18.2071 54.5477 18.305 54.5139 18.3638 54.4378C19.7295 52.5728 20.9469 50.6063 21.9907 48.5383C22.0523 48.4172 21.9935 48.2735 21.8676 48.2256C19.9366 47.4931 18.0979 46.6 16.3292 45.5858C16.1893 45.5041 16.1781 45.304 16.3068 45.2082C16.679 44.9293 17.0513 44.6391 17.4067 44.3461C17.471 44.2926 17.5606 44.2813 17.6362 44.3151C29.2558 49.6202 41.8354 49.6202 53.3179 44.3151C53.3935 44.2785 53.4831 44.2898 53.5502 44.3433C53.9057 44.6363 54.2779 44.9293 54.6529 45.2082C54.7816 45.304 54.7732 45.5041 54.6333 45.5858C52.8646 46.6197 51.0259 47.4931 49.0921 48.2228C48.9662 48.2707 48.9102 48.4172 48.9718 48.5383C50.038 50.6034 51.2554 52.5699 52.5959 54.435C52.6519 54.5139 52.7526 54.5477 52.845 54.5195C58.6464 52.7249 64.529 50.0174 70.6019 45.5576C70.6551 45.5182 70.6887 45.459 70.6943 45.3942C72.1747 30.0791 68.2147 16.7757 60.1968 4.9823C60.1772 4.9429 60.1437 4.9147 60.1045 4.8978ZM23.7259 37.3253C20.2276 37.3253 17.3451 34.1136 17.3451 30.1693C17.3451 26.225 20.1717 23.0133 23.7259 23.0133C27.308 23.0133 30.1626 26.2532 30.1066 30.1693C30.1066 34.1136 27.28 37.3253 23.7259 37.3253ZM47.3178 37.3253C43.8196 37.3253 40.9371 34.1136 40.9371 30.1693C40.9371 26.225 43.7636 23.0133 47.3178 23.0133C50.9 23.0133 53.7545 26.2532 53.6986 30.1693C53.6986 34.1136 50.9 37.3253 47.3178 37.3253Z"
											fill="#fff"
										/>
									</g>
									<defs>
										<clipPath id="clip0">
											<rect width="71" height="55" fill="white" />
										</clipPath>
									</defs>
								</svg>
							</a>
							<a
								href="https://twitter.com/ApyAliens"
								onClick={toggle}
								class=" px-4 py-2 font-semibold text-white inline-flex items-center space-x-2 rounded">
								<svg
									class="w-5 h-5 fill-current"
									role="img"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 24 24">
									<path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
								</svg>
							</a>
							<a
								href="https://t.me/apyaliens"
								onClick={toggle}
								class="px-4 py-2 font-semibold text-white inline-flex items-center space-x-2 rounded">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 24 24"
									width="24px"
									height="24px">
									<path
										d="M3 11L21 4 18 20 13 17 9.875 18.5 8 14z"
										opacity=".3"
									/>
									<path
										d="M21.45,3.377c-0.485-0.415-1.209-0.492-1.935-0.205c-0.45,0.177-7.501,3.144-14.074,5.911L3.27,9.997c-0.841,0.341-1.267,0.894-1.267,1.641c0,0.523,0.222,1.234,1.278,1.652l3.667,1.467c0.317,0.951,1.053,3.159,1.238,3.746c0.11,0.348,0.388,1.225,1.09,1.43c0.144,0.049,0.294,0.074,0.447,0.074c0.443,0,0.762-0.206,0.918-0.326l2.329-1.97l2.831,2.617C15.91,20.439,16.486,21,17.261,21c0.967,0,1.701-0.805,1.854-1.584c0.083-0.427,2.812-14.129,2.812-14.127C22.172,4.19,21.733,3.62,21.45,3.377z M17.166,18.866l-4.137-3.826l-3.03,2.565c-0.359-1.107-1.301-3.922-1.301-3.922l-0.146-0.439l-4.021-1.608l1.687-0.709c4.299-1.81,11.956-5.033,13.692-5.755C19.533,7.062,17.478,17.379,17.166,18.866z"
										fill="#fff"
									/>
									<path
										d="M16.8,8c-0.125,0-0.294,0.119-0.384,0.175c-1.288,0.803-7.746,4.478-9.517,5.484C7.398,13.859,7.75,14,7.75,14s1.151,3.445,1.39,4.2c0.239,0.756,0.431,0.774,0.431,0.774c0.053,0.023,0.105,0.032,0.153,0.032c0.039,0,0.066-0.014,0.099-0.023L11,14.375c0,0,5.363-5.428,5.686-5.744C16.946,8.378,17,8.289,17,8.201C17,8.084,16.939,8,16.8,8z"
										fill="#fff"
									/>
								</svg>
							</a>
							<a
								href="https://www.instagram.com/apyaliens/"
								onClick={toggle}
								class=" px-4 py-2 font-semibold text-white inline-flex items-center space-x-2 rounded">
								<svg
									fill="#000000"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 24 24"
									width="24px"
									height="24px">
									<path
										d="M 3 3 L 3 21 L 21 21 L 21 3 L 3 3 z M 18 5 C 18.552 5 19 5.448 19 6 C 19 6.552 18.552 7 18 7 C 17.448 7 17 6.552 17 6 C 17 5.448 17.448 5 18 5 z M 12 7 C 14.761 7 17 9.239 17 12 C 17 14.761 14.761 17 12 17 C 9.239 17 7 14.761 7 12 C 7 9.239 9.239 7 12 7 z M 12 9 A 3 3 0 0 0 9 12 A 3 3 0 0 0 12 15 A 3 3 0 0 0 15 12 A 3 3 0 0 0 12 9 z"
										fill="#fff"
									/>
								</svg>
							</a>
						</div>
					</Sidenav>
				</div>
			</div>
		</nav>
	);
}

/* Sidenav logic */

const style = {
	item: `flex justify-center items-center h-full cursor-pointer font-medium hover:text-gray-400 ml-8 mb-10`,
	closeIcon: `absolute top-1 focus:outline-none right-3 text-5xl text-white cursor-pointer`,
	sidenav: {
		open: `w-8/12 md:w-5/12 bg-gray-800 text-white overflow-x-hidden`,
		close: `w-0 bg-gray-800 text-white overflow-x-hidden`,
		default: `h-screen fixed z-20 top-0 right-0 transition-all ease duration-200`,
	},
};

function Sidenav({ open, toggle, children }) {
	const ref = React.useRef(null);

	//close on click outside
	React.useEffect(() => {
		const handleOutsideClick = (event) => {
			if (!ref.current?.contains(event.target)) {
				if (!open) return;
				toggle(false);
			}
		};
		window.addEventListener("mousedown", handleOutsideClick);
		return () => window.removeEventListener("mousedown", handleOutsideClick);
	}, [open, ref, toggle]);

	return (
		<aside
			ref={ref}
			className={`${style.sidenav.default} 
		  ${open ? style.sidenav.open : style.sidenav.close}`}>
			<button aria-label="Close" className={style.closeIcon} onClick={toggle}>
				&times;
			</button>
			<div className="mt-12">{children}</div>
		</aside>
	);
}

function SidenavItem({ children, href }) {
	return (
		<a href={href} className={style.item}>
			{children}
		</a>
	);
}

export default Navbar;
